import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonButton, IonIcon, IonContent, IonList, IonItem, IonLabel } from '@ionic/angular/standalone';
import {SexyModule} from '@qid/sexy';
import {Router} from '@angular/router';
import {MasterTemplate} from '../../models/MasterTemplate';
import {MasterTemplateService} from "../../components/services/master-template.service";
import {AlertController, LoadingController} from "@ionic/angular/standalone";
import {DisplayService, ValidationUtil} from "@qid/core";
import {CreateMasterTemplateDto} from "../../dto/create-master-template.dto";
import {CollectionTemplateService, CreateCollectionTemplateDto} from "../../../collection-template";

@Component({
    selector: 'app-list-master-template',
    templateUrl: './list-master-template.page.html',
    styleUrls: ['./list-master-template.page.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        SexyModule,
        IonHeader,
        IonToolbar,
        IonTitle,
        IonButton,
        IonIcon,
        IonContent,
        IonList,
        IonItem,
        IonLabel
    ]
})
export class ListMasterTemplatePage implements OnInit {
    public masterTemplates: MasterTemplate[] = [];

    constructor(
        private masterTemplateService: MasterTemplateService,
        private collectionTemplateService: CollectionTemplateService,
        private router: Router,
        private alertController: AlertController,
        private displayService: DisplayService,
        private loadingController: LoadingController
    ) {
    }

    ngOnInit() {
    }

    ionViewDidEnter() {
        this.fetchMasterTemplates();
    }

    async fetchMasterTemplates() {
        this.masterTemplates = await this.masterTemplateService.readAll();
    }


    createCollectionTemplate = async () => {

        const alert = await this.alertController.create({
            header: "Create New Master Form",
            subHeader: 'Please enter a name for your new form.',
            inputs: [
                {
                    label: "Form Name",
                    placeholder: 'Form Name',
                    name: 'formName'
                }
            ],
            buttons: [
                {
                    text: "Cancel",
                    role: "cancel"
                },
                {
                    text: 'Create',
                    handler: async (data) => {
                        if (ValidationUtil.isStringEmpty(data.formName)) {
                            this.displayService.toast({message: "Form name cannot be empty"})
                            return false
                        }
                        let dto = new CreateCollectionTemplateDto();
                        dto.purpose = data.formName;
                        const loader = await this.loadingController.create({message: "Creating Form"});
                        loader.present();
                        const template = await this.createMasterTemplate(dto);
                        if (template) {
                            loader.dismiss();
                            this.displayService.toast({message: 'Form Created', color: "success"});
                            this.fetchMasterTemplates()
                        } else {
                            loader.dismiss();
                            this.displayService.toast({message: "Template not created", color: "warning"});
                        }

                    }
                }
            ]
        })

        alert.present();

    }

    openMasterTemplate(masterTemplate: MasterTemplate) {
        this.router.navigate(['menu', 'templates', masterTemplate?.template?._id], {
            queryParams: {masterTemplate_id: masterTemplate?._id}
        });

    }


    public createMasterTemplate = async (dto: CreateCollectionTemplateDto) => {


        const template = await this.collectionTemplateService.create(dto);

        if (!template || !template._id) {
            throw 'Template was not created';
        }

        const createMasterTemplateDto: CreateMasterTemplateDto =
            new CreateMasterTemplateDto();
        createMasterTemplateDto.template = template._id;
        return this.masterTemplateService.create(createMasterTemplateDto);
    };

}
